import { clsx } from 'clsx';

import type { PropsWithChildren } from 'react';

import styles from './Container.module.css';

interface ContainerProps {
  size?: 'small' | 'medium' | 'large' | 'large-full-height';
  visible?: boolean;
  centerContent?: boolean;
  padded?: boolean;
}

export const Container = ({
  children,
  size = 'medium',
  centerContent = false,
  visible = true,
  padded = true,
}: PropsWithChildren<ContainerProps>) => {
  const label = padded ? 'Storybook container with 1rem padding' : 'Storybook container';

  return (
    <>
      <label htmlFor="container">{label}</label>
      <div
        id="container"
        className={clsx(styles['container'], {
          [styles['container--small']]: size === 'small',
          [styles['container--medium']]: size === 'medium',
          [styles['container--large']]: size === 'large',
          [styles['container--large-full-height']]: size === 'large-full-height',
          [styles['container--padded']]: padded,
          [styles['container--centered-content']]: centerContent,
          [styles['container--hidden']]: !visible,
        })}
      >
        {children}
      </div>
    </>
  );
};
